import { observable, action, makeObservable } from 'mobx';
import { GoalsApi } from '../../../../apis/goals';
import { YearlyGoal } from '../../../../types/goals';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';

export class YearlyGoalPaneState {
  yearlyGoal: RemoteResourceV3<YearlyGoal> = RemoteResourceV3.loading();

  constructor() {
    makeObservable(this, {
      yearlyGoal: observable,
      loadYearlyGoal: action.bound,
      setYearlyGoal: action.bound,
    });
  }

  init() {
    this.loadYearlyGoal();
  }

  async loadYearlyGoal() {
    updateRemoteResourceV3(
      this.yearlyGoal,
      (v) => (this.yearlyGoal = v),
      () => GoalsApi.findYearlyGoal()
    );
  }

  async setYearlyGoal(files) {
    if (files && files[0]) {
      const [file] = files;
      const formData = new FormData();
      formData.append('yearly_goal', file);
      await GoalsApi.updateYearlyGoal(formData);
      this.loadYearlyGoal();
    }
  }
}
